import React, { useState, useRef, useEffect } from 'react'
import './index.scss'
import classnames from 'classnames'
import LazyLoad from 'react-lazyload'
import { useTranslation } from '../../i18n'
/**
 * @param images 默认取第一张
 */
const getImgPath = (images: any[]) => {
  if (images === void 0 || images.length === 0) {
    return ''
  }
  if (images[0].thumbnail !== void 0 && images[0].thumbnail.url !== void 0) {
    return images[0].thumbnail.url + '?x-oss-process=image/resize,l_300'
  } else if (images[0].full !== void 0 && images[0].full.url !== void 0) {
    return images[0].full.url + '?x-oss-process=image/resize,l_300'
  }
  return ''
}

export interface IImageModel {
  full?: any
  thumbnail?: any
}

export interface IProductModel {
  colors: any[]
  displayBrand: string
  brand: string
  originalPriceTag: string
  priceTagCN: string
  priceTag: string
  images: IImageModel[]
}

export interface IRankProdutModel {
  product: IProductModel | any
  origin: string
  merchantName: string
  favoritedCount: number
  activityOffs: string[]
}

export interface IProductProps {
  productInfo: IRankProdutModel | any
  className?: string
  clickTo?: (type, path1, path2, componentId) => void
  index: number
  pid?: string
}

const RowProduct = (props: IProductProps) => {
  const { t } = useTranslation()
  const mounted: any = useRef()
  const [update, setUpdate] = useState(false)
  const { productInfo, className, clickTo, index, pid } = props

  const { product, off, activityOffs } = productInfo
  const classes = classnames('lego_rowProduct', className)
  const productName =
    (product.displayBrand
      ? `${product.displayBrand} | `
      : `${product.brand} | `) + (product.nameCN || product.name)
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true
      setUpdate(false)
    } else {
      setUpdate(true)
    }
  }, [])
  return (
    <div
      className={classes}
      onClick={() => clickTo('product', product.id, '', pid)}
      data-productid={product.id}
      data-pid={pid}
      data-id={product.id}
      data-index={index}
    >
      <div className="rowProduct_imgBox">
        <LazyLoad
          // overflow={true}
          height={80}
          scrollContainer={'.pageContent'}
          classNamePrefix="lazyimgContent"
          offset={20}
        >
          <img src={getImgPath(product.images)} />
        </LazyLoad>
        {product.colors.length > 1 ? (
          <div className="rowProduct_imgBox_colors">
            {product.colors.length}色可选
          </div>
        ) : (
          <div />
        )}
        {product.inventoryStatus !== 'AVAILABLE' && (
          <div className="selloutContent">{t("SOLD_OUT")}</div>
        )}
      </div>
      <div className="rowProduct_textBox">
        <div className="rowProduct_textBox_title">{productName}</div>
        <div className="rowProduct_priceTagSection">
          <span
            className={`rowProduct_priceTagCN ${
              product.originalPriceTag ? 'blueColor' : ''
            }`}
          >
            {product.priceTagCN}
          </span>
        </div>
        <div className="rowProduct_priceTagCNSection"></div>
        {(off || activityOffs?.length > 0) && (
          <div className="promoMsg">
            {off && <span className="promoItem off">{off}</span>}
            {activityOffs &&
              activityOffs.map((val, index) => {
                {
                  return (
                    <span className="promoItem" key={`off${index}`}>
                      {val}
                    </span>
                  )
                }
              })}
          </div>
        )}
      </div>
    </div>
  )
}
export default RowProduct
